import Head from 'next/head';
import React from 'react';

interface SchemaMarkupProps {
  schemas: any | any[];
  id?: string;
}

/**
 * Component for rendering JSON-LD schema markup
 */
export const SchemaMarkup: React.FC<SchemaMarkupProps> = ({ schemas, id = 'schema-markup' }) => {
  // Handle both single schema and array of schemas
  const schemaArray = Array.isArray(schemas) ? schemas : [schemas];

  // Filter out null/undefined schemas
  const validSchemas = schemaArray.filter(Boolean);

  if (validSchemas.length === 0) {
    return null;
  }

  // If multiple schemas, wrap in @graph
  const finalSchema =
    validSchemas.length === 1
      ? validSchemas[0]
      : {
          '@context': 'https://schema.org',
          '@graph': validSchemas.map((schema) => {
            // Remove @context from individual schemas when combining
            // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/naming-convention -- we don't need the context
            const { '@context': _, ...rest } = schema;
            return rest;
          }),
        };

  return (
    <Head>
      <script
        type='application/ld+json'
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(finalSchema, null, 2).replace(/</g, '\\u003c'),
        }}
        key={id}
      />
    </Head>
  );
};
